import { FC } from 'react'
import { Button, Stack, Typography, useMediaQuery } from '@mui/material'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { useTheme } from '@emotion/react'
import useStyles from './_styles'
import { DeletionSectionProps } from './_props'

const DeletionSection: FC<DeletionSectionProps> = ({
    marginTop,
    buttonText,
    bannerLabel,
    bannerSubLabel,
    onConfirm,
}) => {
    const theme: any = useTheme()
    const isLarge = useMediaQuery(theme.breakpoints.up('md'))
    const classes = useStyles()

    return (
        <div
            style={{
                marginTop,
            }}
            className={classes.DeletionBanner}
        >
            <Stack direction="column" alignItems="flex-start">
                <Typography className={classes.DeletionBannerLabel}>{bannerLabel}</Typography>
                {bannerSubLabel && <Typography className={classes.DeletionBannerSubLabel}>{bannerSubLabel}</Typography>}
            </Stack>
            <Button
                variant="contained"
                disableElevation
                color="inherit"
                onClick={onConfirm}
                className={classes.DeletionBannerButton}
                startIcon={<DeleteOutlineRoundedIcon className={classes.DeletionBannerButtonIcon} />}
                data-cy="deletionBanner-delete"
            >
                {isLarge && (buttonText || 'Supprimer')}
            </Button>
        </div>
    )
}

export default DeletionSection
